/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.
*/

import {
	Component,
	ContentChildren,
	type QueryList,
	input,
	output
} from "@angular/core";
import {
	ButtonComponent,
	type CbSubmitEvent,
} from "@app/widgets/base/button/button.component";
import { Subject, takeUntil } from "rxjs";

@Component({
	selector: "cb-form-controls",
	templateUrl: "./form-controls.component.html",
	styleUrl: "./form-controls.component.scss",
	standalone: false,
	//changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormControlsComponent {
	public readonly layout = input<"row" | "col">("row");

	public submit = output<CbSubmitEvent>();

	private destroy$ = new Subject<void>();

	@ContentChildren(ButtonComponent)
	public set buttons(values: QueryList<ButtonComponent>) {
		this.destroy$.next();
		this.destroy$.complete();

		this.destroy$ = new Subject<void>();

		for (const btn of values) {
			if (btn.type() === "submit") {
				btn.submit
					.pipe(takeUntil(this.destroy$))
					.subscribe((event: CbSubmitEvent) => {
						this.submit.emit(event);
					});
			}
		}
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
